<template>
	<div class="login">
		<div class="loginBox">
			<div class="titleBox">用户登录</div>
			<div class="inputBpx">
				<div class="nameBox itemBox disBetween">
					<div class="my"></div>
					<span class="line"></span>
					<div class="textBpx">
						<el-input v-model="obj.value1" placeholder="请输入用户名 / 手机"></el-input>
					</div>
				</div>
				<div class="pasBox itemBox disBetween">
					<div class="pas"></div>
					<span class="line"></span>
					<div class="textBpx">
						<el-input placeholder="请输入密码" v-model="obj.value2" show-password></el-input>
					</div>
				</div>
				<div class="forget">忘记密码？</div>
			</div>
			<div class="loginBtn disCenter">
				<el-button @click="goLogin" type="primary">登录</el-button>
			</div>
		</div>
		<div class="valueBox disCenter" @click="goUrl">© 南京岳华智能科技有限公司 版权所有 | 备案许可证编号： 苏ICP备2023016249号-1</div>
	</div>
</template>

<script type="text/javascript">
	export default{
		data() {
			return {
				obj:{
					value1:"",
					value2:""
				}
			}
		},
		mounted() {
		},
		methods:{
			goUrl(){
				window.open("https://beian.miit.gov.cn")
			},
			goLogin(){
				// alert("点击了登录")
				if(this.obj.value1.length==0){
					this.$message('请输入用户名');
					return
				}if(this.obj.value2.length==0){
					this.$message('请输入密码');
					return
				}
				this.gotoLogin()
				
			},
			gotoLogin() {
				this.$api.login({
					loginName:this.obj.value1,
					loginPassword:this.obj.value2
				}).then(res => {
					console.log(res)
					if(res.returnCode ==200){
						localStorage.setItem('token',res.obj.token)
						this.$router.push('myMap')
					}else{
						if(res.returnMessage){
							this.$message(res.returnMessage);
						}else{
							this.$message('数据请求失败');
						}
						
					}
					
					
				}).catch(function(error) {
					console.log(error);
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "login.scss"
</style>